<div class="w-full max-w-[60rem] mx-auto">
  <workspace-breadcrumb class="block mb-6" />
  <div class="flex md:flex-row flex-col gap-8">
    <!-- Left Column -->
    <div class="left-column flex flex-col gap-6">
      <!-- Current Card Spending Card -->
      <div class="card bg-white p-5 md:p-6 flex items-center gap-4 rounded-lg md:rounded">
        <div class="bg-[#E6F2FA] rounded-full p-2 w-20 h-20 flex items-center justify-center">
          <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 40 40" fill="none">
            <path
              d="M23.9262 5.99288C24.0742 5.805 24.3497 5.78002 24.5292 5.93822L26.0642 7.29187L21.2305 13.334H24.432L27.9413 8.94727L30.695 11.3755C30.8643 11.5248 30.884 11.7819 30.7392 11.9552L29.5872 13.334H32.8275C33.6508 12.1322 33.463 10.4831 32.3485 9.50039L26.1827 4.06313C24.9268 2.95573 22.9985 3.13058 21.9625 4.4458L14.9603 13.334H18.143L23.9262 5.99288ZM27.0833 25.0007C26.393 25.0007 25.8333 25.5603 25.8333 26.2507C25.8333 26.941 26.393 27.5007 27.0833 27.5007H30.4167C31.107 27.5007 31.6667 26.941 31.6667 26.2507C31.6667 25.5603 31.107 25.0007 30.4167 25.0007H27.0833ZM7.5 13.7507C7.5 13.0603 8.05965 12.5007 8.75 12.5007H13.9641L15.95 10.0007H8.75C6.67893 10.0007 5 11.6796 5 13.7507V31.2507C5 34.2422 7.42512 36.6673 10.4167 36.6673H30.4167C33.4082 36.6673 35.8333 34.2422 35.8333 31.2507V20.4173C35.8333 17.4258 33.4082 15.0007 30.4167 15.0007H8.75C8.05965 15.0007 7.5 14.441 7.5 13.7507ZM7.5 31.2507V17.2873C7.89097 17.4255 8.3117 17.5007 8.75 17.5007H30.4167C32.0275 17.5007 33.3333 18.8065 33.3333 20.4173V31.2507C33.3333 32.8615 32.0275 34.1673 30.4167 34.1673H10.4167C8.80583 34.1673 7.5 32.8615 7.5 31.2507Z"
              fill="#007DCB"
            />
          </svg>
        </div>
        <div class="flex-1">
          <p class="text-[28px] md:text-[31px] font-bold text-[#003555] leading-[140%] md:leading-tight">
            {{ memberSummaryCardsResource.hasValue() ? (cardSpending() | balanceMoney) : '—' }}
          </p>
          <p class="text-[16px] md:text-[18px] text-[#005990] leading-[160%] md:leading-normal">
            {{ 'cardDetails.currentCardSpending' | translate }}
          </p>
        </div>
      </div>

      @if (memberSummaryCardsResource.status() === 'error') {
        <app-resource-load-error data-resource="summary" (retry)="memberSummaryCardsResource.reload()" />
      }
      <!-- Info Cards -->
      <div class="flex flex-col md:flex-row gap-6">
        <!-- Reload Locations Card -->
        <div
          class="flex-1 h-full justify-between bg-[#E6F2FA] border border-[#EEEEEF] rounded p-5 flex flex-col gap-6 items-center"
        >
          <div class="flex flex-col gap-4 items-center text-center">
            <div class="w-16 h-16">
              <img src="../../../../../assets/img/deposit-locations.svg" alt="Deposit Locations" />
            </div>
            <p class="text-[18px] font-bold text-[#2C3035]">{{ 'cardDetails.reloadLocations.title' | translate }}</p>
            <p class="text-[15px] text-[#505760]">{{ 'cardDetails.reloadLocations.description' | translate }}</p>
          </div>
          <korviu-button
            class="card-button"
            [style.--button__border-radius]="'0.375rem'"
            [color]="'tertiary'"
            [size]="'x-small'"
            (onclick)="openReloadLocations()"
          >
            <span class="text-[0.9375rem] text-wrap">{{ 'cardDetails.reloadLocations.button' | translate }}</span>
          </korviu-button>
        </div>

        <!-- Direct Deposit Card -->
        <div
          class="flex-1 h-full justify-between bg-[#F2F7ED] border border-[#EEEEEF] rounded p-5 flex flex-col gap-6 items-center"
        >
          <div class="flex flex-col gap-4 items-center text-center">
            <div class="w-16 h-16">
              <img src="../../../../../assets/img/employer-deposit.svg" alt="Deposit Locations" />
            </div>
            <p class="text-[18px] font-bold text-[#2C3035]">{{ 'cardDetails.directDeposit.title' | translate }}</p>
            <p class="text-[15px] text-[#505760]">{{ 'cardDetails.directDeposit.description' | translate }}</p>
          </div>
          <korviu-button
            class="card-button"
            [style.--button__border-radius]="'0.375rem'"
            [color]="'primary'"
            [size]="'x-small'"
            (onclick)="openDirectDepositForm()"
          >
            <div class="flex items-center justify-center gap-2">
              <span class="text-[0.9375rem] text-center text-wrap">
                {{ 'cardDetails.directDeposit.button' | translate }}
              </span>
              <i>
                <svg xmlns="http://www.w3.org/2000/svg" width="15" height="16" viewBox="0 0 15 16" fill="none">
                  <path
                    d="M2.70827 1.75C1.90287 1.75 1.24997 2.40292 1.24997 3.20833V12.7917C1.24997 13.5971 1.90287 14.25 2.70827 14.25H12.2913C13.0967 14.25 13.7497 13.5971 13.7497 12.7917V9.45833C13.7497 9.11317 14.0295 8.83333 14.3747 8.83333C14.7198 8.83333 14.9996 9.11317 14.9996 9.45833V12.7917C14.9996 14.2874 13.7871 15.5 12.2913 15.5H2.70827C1.21253 15.5 0 14.2874 0 12.7917V3.20833C0 1.71256 1.21253 0.5 2.70827 0.5H6.0415C6.38667 0.5 6.6665 0.779825 6.6665 1.125C6.6665 1.47018 6.38667 1.75 6.0415 1.75H2.70827ZM8.33308 1.125C8.33308 0.779825 8.61292 0.5 8.95808 0.5H14.375C14.7202 0.5 15 0.779825 15 1.125V6.54167C15 6.88683 14.7202 7.16667 14.375 7.16667C14.0298 7.16667 13.75 6.88683 13.75 6.54167V2.63395L9.4 6.98367C9.15592 7.22767 8.76025 7.22767 8.51617 6.98358C8.27208 6.7395 8.27208 6.34375 8.51617 6.0997L12.8663 1.75H8.95808C8.61292 1.75 8.33308 1.47018 8.33308 1.125Z"
                    fill="#FCFCFC"
                  />
                </svg>
              </i>
            </div>
          </korviu-button>
        </div>
      </div>

      <!-- Chart Card -->
      <div class="flex flex-col gap-2 p-6 user-card rounded-[0.25rem]">
        <div class="flex flex-col">
          <span class="text-[#505760] text-[1.625rem]/[160%] font-bold">
            {{ 'cardDetails.chart.title' | translate }}
          </span>
          <span class="text-[#737980] text-[1.125rem]/[160%]">{{ 'cardDetails.chart.subtitle' | translate }}</span>
        </div>
        @if (earningsTableResource.status() === 'error') {
          <app-resource-load-error data-resource="table" (retry)="earningsTableResource.reload()" />
        } @else if (earningsTableResource.hasValue()) {
          <div>
            <apx-chart
              [series]="earningsGrowthChartOptions()?.series"
              [chart]="earningsGrowthChartOptions()?.chart"
              [xaxis]="earningsGrowthChartOptions()?.xaxis"
              [yaxis]="earningsGrowthChartOptions()?.yaxis"
              [plotOptions]="earningsGrowthChartOptions()?.plotOptions"
              [dataLabels]="earningsGrowthChartOptions()?.dataLabels"
              [legend]="earningsGrowthChartOptions()?.legend"
              [tooltip]="earningsGrowthChartOptions()?.tooltip"
              [grid]="earningsGrowthChartOptions()?.grid"
              [colors]="earningsGrowthChartOptions()?.colors"
              [title]="earningsGrowthChartOptions()?.title"
              [subtitle]="earningsGrowthChartOptions()?.subtitle"
              [responsive]="earningsGrowthChartOptions()?.responsive"
              [states]="earningsGrowthChartOptions()?.states"
            />
          </div>
          <div>
            @if (monthlySpendingTrend(); as trend) {
              <div class="flex gap-1 items-center w-full">
                <span class="text-[1.125rem]/[160%] text-[#505760]">
                  {{
                    (trend.direction === 'up'
                      ? 'cardDetails.chart.trendingUpVsPreviousMonth'
                      : 'cardDetails.chart.trendingDownVsPreviousMonth'
                    ) | translate: { count: trend.percentage }
                  }}
                </span>
                <i [style.transform]="trend.direction === 'down' ? 'rotate(90deg)' : null">
                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="25" viewBox="0 0 24 25" fill="none">
                    <path
                      d="M13.7489 6L21.3027 6.00052L21.403 6.01444L21.5018 6.04205L21.5621 6.0676C21.6413 6.10246 21.7155 6.15315 21.7808 6.21836L21.8215 6.2624L21.865 6.31878L21.9192 6.4089L21.9579 6.49922L21.977 6.5633L21.9906 6.6273L22 6.7215L22.0004 14.2539C22.0004 14.6681 21.6647 15.0039 21.2504 15.0039C20.8708 15.0039 20.557 14.7217 20.5073 14.3557L20.5004 14.2539L20.5 8.559L12.7812 16.2793C12.5149 16.5455 12.0982 16.5698 11.8046 16.3519L11.7205 16.2793L8.75001 13.3089L3.28033 18.7786C2.98744 19.0715 2.51256 19.0715 2.21967 18.7786C1.9534 18.5123 1.9292 18.0957 2.14705 17.8021L2.21967 17.7179L8.21967 11.7179C8.48593 11.4517 8.90259 11.4275 9.1962 11.6453L9.28032 11.7179L12.2508 14.6883L19.438 7.5H13.7489C13.3692 7.5 13.0554 7.21785 13.0058 6.85177L12.9989 6.75C12.9989 6.3703 13.2811 6.05651 13.6472 6.00685L13.7489 6Z"
                      [attr.fill]="trend.direction === 'up' ? '#078339' : '#D14343'"
                    />
                  </svg>
                </i>
              </div>
            }
            <span class="text-[0.9375rem]/[160%] text-[#737980]">{{
              'cardDetails.chart.showingSpending' | translate
            }}</span>
          </div>
        }
      </div>
    </div>

    <!-- Right Column -->
    <div class="right-column flex flex-col gap-6">
      <!-- Illustration & Text -->
      <div class="flex flex-col gap-8">
        <!-- Illustration -->
        <div class="w-full flex items-center justify-center">
          <img
            src="../../../../../assets/img/okeey-cash-card-hands.svg"
            class="w-full h-auto"
            alt="Deposit Locations"
          />
        </div>

        <!-- Info Text -->
        <div class="flex flex-col gap-6 text-[18px] text-[#505760]">
          <p>{{ 'cardDetails.info.text1' | translate }}</p>
          <p>{{ 'cardDetails.info.text2' | translate }}</p>
        </div>
      </div>

      <!-- View Fee Details Button -->
      <korviu-button [style.--button__border-radius]="'0.375rem'" [color]="'ghost'" [size]="'small'">
        {{ 'cardDetails.viewFeeDetails' | translate }}
      </korviu-button>

      <!-- Fee Dropdowns -->
      <div class="flex flex-col gap-5">
        <!-- Standard Fees -->
        <nz-collapse [nzBordered]="true" [nzAccordion]="true" [nzExpandIconPosition]="'end'" class="card">
          <nz-collapse-panel
            [nzHeader]="'cardDetails.fees.standardFees.title' | translate"
            [nzActive]="activePanels[0]"
            (nzActiveChange)="onPanelChange(0, $event)"
          >
            <div class="bg-[#fcfcfc] border border-[#eeeeef] rounded-2xl overflow-hidden mx-4 mb-4 mt-2 p-4">
              <div class="flex items-center">
                <!-- Description Column -->
                <div class="flex-1 flex flex-col">
                  <!-- Table Header -->
                  <div class="flex items-center h-10 px-6 py-2 bg-[#fcfcfc] border-b border-[#eeeeef]">
                    <p class="text-[15px] font-bold text-[#2c3035]">
                      {{ 'cardDetails.fees.standardFees.description' | translate }}
                    </p>
                  </div>

                  <!-- Table Rows -->
                  <div class="flex items-center h-14 px-6 py-2 bg-[#e6f2fa]">
                    <p class="text-[15px] font-bold text-[#393e44] line-clamp-2">
                      {{ 'cardDetails.fees.standardFees.cardPurchaseFee' | translate }}
                    </p>
                  </div>

                  <div class="flex items-center h-14 px-6 py-2 bg-[#fcfcfc]">
                    <p class="text-[15px] font-bold text-[#393e44] line-clamp-2">
                      {{ 'cardDetails.fees.standardFees.signaturePurchase' | translate }}
                    </p>
                  </div>

                  <div class="flex items-center h-14 px-6 py-2 bg-[#e6f2fa]">
                    <p class="text-[15px] font-bold text-[#393e44] line-clamp-2">
                      {{ 'cardDetails.fees.standardFees.pinPurchase' | translate }}
                    </p>
                  </div>

                  <div class="flex items-center h-14 px-6 py-2 bg-[#fcfcfc]">
                    <p class="text-[15px] font-bold text-[#393e44] line-clamp-2">
                      {{ 'cardDetails.fees.standardFees.atmWithdrawalDomestic' | translate }}
                    </p>
                  </div>

                  <div class="flex items-center h-14 px-6 py-2 bg-[#e6f2fa]">
                    <p class="text-[15px] font-bold text-[#393e44] line-clamp-2">
                      {{ 'cardDetails.fees.standardFees.cashBackAtPos' | translate }}
                    </p>
                  </div>
                </div>

                <!-- Fee Column -->
                <div class="w-[100px] flex flex-col">
                  <!-- Table Header -->
                  <div class="flex items-center justify-end h-10 px-6 py-2 bg-[#fcfcfc] border-b border-[#eeeeef]">
                    <p class="text-[15px] font-bold text-[#2c3035]">
                      {{ 'cardDetails.fees.standardFees.fee' | translate }}
                    </p>
                  </div>

                  <!-- Table Rows -->
                  <div class="flex items-center justify-end h-14 px-6 py-2 bg-[#e6f2fa]">
                    <p class="text-[15px] text-[#393e44]">$10.00</p>
                  </div>

                  <div class="flex items-center justify-end h-14 px-6 py-2 bg-[#fcfcfc]">
                    <p class="text-[15px] text-[#393e44]">$0.00</p>
                  </div>

                  <div class="flex items-center justify-end h-14 px-6 py-2 bg-[#e6f2fa]">
                    <p class="text-[15px] text-[#393e44]">$0.00</p>
                  </div>

                  <div class="flex items-center justify-end h-14 px-6 py-2 bg-[#fcfcfc]">
                    <p class="text-[15px] text-[#393e44]">$2.50</p>
                  </div>

                  <div class="flex items-center justify-end h-14 px-6 py-2 bg-[#e6f2fa]">
                    <p class="text-[15px] text-[#393e44]">$0.50</p>
                  </div>
                </div>
              </div>
            </div>
          </nz-collapse-panel>
        </nz-collapse>

        <!-- Transfer Fees -->
        <nz-collapse [nzBordered]="true" [nzAccordion]="true" [nzExpandIconPosition]="'end'" class="card">
          <nz-collapse-panel
            [nzHeader]="'cardDetails.fees.transferFees.title' | translate"
            [nzActive]="activePanels[1]"
            (nzActiveChange)="onPanelChange(1, $event)"
          >
            <div class="bg-[#fcfcfc] border border-[#eeeeef] rounded-2xl overflow-hidden mx-4 mb-4 mt-2 p-4">
              <div class="flex items-center">
                <!-- Description Column -->
                <div class="flex-1 flex flex-col">
                  <!-- Table Header -->
                  <div class="flex items-center h-10 px-6 py-2 bg-[#fcfcfc] border-b border-[#eeeeef]">
                    <p class="text-[15px] font-bold text-[#2c3035]">
                      {{ 'cardDetails.fees.standardFees.description' | translate }}
                    </p>
                  </div>

                  <!-- Table Rows -->
                  <div class="flex items-center h-14 px-6 py-2 bg-[#e6f2fa]">
                    <p class="text-[15px] font-bold text-[#393e44] line-clamp-2">
                      {{ 'cardDetails.fees.transferFees.directDeposit' | translate }}
                    </p>
                  </div>

                  <div class="flex items-center h-16 px-6 py-2 bg-[#fcfcfc]">
                    <p class="text-[15px] font-bold text-[#393e44] line-clamp-2">
                      {{ 'cardDetails.fees.transferFees.bankToCard' | translate }}
                    </p>
                  </div>

                  <div class="flex items-center h-16 px-6 py-2 bg-[#e6f2fa]">
                    <p class="text-[15px] font-bold text-[#393e44] line-clamp-2">
                      {{ 'cardDetails.fees.transferFees.cardToCard' | translate }}
                    </p>
                  </div>

                  <div class="flex items-center h-16 px-6 py-2 bg-[#fcfcfc]">
                    <p class="text-[15px] font-bold text-[#393e44] line-clamp-2">
                      {{ 'cardDetails.fees.transferFees.cardToBank' | translate }}
                    </p>
                  </div>
                </div>

                <!-- Fee Column -->
                <div class="w-[100px] flex flex-col">
                  <!-- Table Header -->
                  <div class="flex items-center justify-end h-10 px-6 py-2 bg-[#fcfcfc] border-b border-[#eeeeef]">
                    <p class="text-[15px] font-bold text-[#2c3035]">
                      {{ 'cardDetails.fees.standardFees.fee' | translate }}
                    </p>
                  </div>

                  <!-- Table Rows -->
                  <div class="flex items-center justify-end h-14 px-6 py-2 bg-[#e6f2fa]">
                    <p class="text-[15px] text-[#393e44]">$10.00</p>
                  </div>

                  <div class="flex items-center justify-end h-16 px-6 py-2 bg-[#fcfcfc]">
                    <p class="text-[15px] text-[#393e44]">$0.00</p>
                  </div>

                  <div class="flex items-center justify-end h-16 px-6 py-2 bg-[#e6f2fa]">
                    <p class="text-[15px] text-[#393e44]">$0.00</p>
                  </div>

                  <div class="flex items-center justify-end h-16 px-6 py-2 bg-[#fcfcfc]">
                    <p class="text-[15px] text-[#393e44]">$2.50</p>
                  </div>
                </div>
              </div>
            </div>
          </nz-collapse-panel>
        </nz-collapse>

        <!-- Outside US Card Use -->
        <nz-collapse [nzBordered]="true" [nzAccordion]="true" [nzExpandIconPosition]="'end'" class="card">
          <nz-collapse-panel
            [nzHeader]="'cardDetails.fees.outsideUsCardUse.title' | translate"
            [nzActive]="activePanels[2]"
            (nzActiveChange)="onPanelChange(2, $event)"
          >
            <div class="bg-[#fcfcfc] border border-[#eeeeef] rounded-2xl overflow-hidden mx-4 mb-4 mt-2 p-4">
              <div class="flex items-center">
                <!-- Description Column -->
                <div class="flex-1 flex flex-col">
                  <!-- Table Header -->
                  <div class="flex items-center h-10 px-6 py-2 bg-[#fcfcfc] border-b border-[#eeeeef]">
                    <p class="text-[15px] font-bold text-[#2c3035]">
                      {{ 'cardDetails.fees.standardFees.description' | translate }}
                    </p>
                  </div>

                  <!-- Table Rows -->
                  <div class="flex items-center h-16 px-6 py-2 bg-[#e6f2fa]">
                    <p class="text-[15px] font-bold text-[#393e44] line-clamp-2">
                      {{ 'cardDetails.fees.outsideUsCardUse.internationalTransactionPin' | translate }}
                    </p>
                  </div>

                  <div class="flex items-center h-16 px-6 py-2 bg-[#fcfcfc]">
                    <p class="text-[15px] font-bold text-[#393e44] line-clamp-2">
                      {{ 'cardDetails.fees.outsideUsCardUse.internationalTransactionSignature' | translate }}
                    </p>
                  </div>

                  <div class="flex items-center h-14 px-6 py-2 bg-[#e6f2fa]">
                    <p class="text-[15px] font-bold text-[#393e44] line-clamp-2">
                      {{ 'cardDetails.fees.outsideUsCardUse.internationalAtmWithdrawal' | translate }}
                    </p>
                  </div>

                  <div class="flex items-center h-16 px-6 py-2 bg-[#fcfcfc]">
                    <p class="text-[15px] font-bold text-[#393e44] line-clamp-2">
                      {{ 'cardDetails.fees.outsideUsCardUse.internationalAtmBalanceInquiry' | translate }}
                    </p>
                  </div>
                </div>

                <!-- Fee Column -->
                <div class="w-[100px] flex flex-col">
                  <!-- Table Header -->
                  <div class="flex items-center justify-end h-10 px-6 py-2 bg-[#fcfcfc] border-b border-[#eeeeef]">
                    <p class="text-[15px] font-bold text-[#2c3035]">
                      {{ 'cardDetails.fees.standardFees.fee' | translate }}
                    </p>
                  </div>

                  <!-- Table Rows -->
                  <div class="flex items-center justify-end h-16 px-6 py-2 bg-[#e6f2fa]">
                    <p class="text-[15px] text-[#393e44]">$0.50</p>
                  </div>

                  <div class="flex items-center justify-end h-16 px-6 py-2 bg-[#fcfcfc]">
                    <p class="text-[15px] text-[#393e44]">$0.00</p>
                  </div>

                  <div class="flex items-center justify-end h-14 px-6 py-2 bg-[#e6f2fa]">
                    <p class="text-[15px] text-[#393e44]">$2.50</p>
                  </div>

                  <div class="flex items-center justify-end h-16 px-6 py-2 bg-[#fcfcfc]">
                    <p class="text-[15px] text-[#393e44]">$0.50</p>
                  </div>
                </div>
              </div>
            </div>
          </nz-collapse-panel>
        </nz-collapse>

        <!-- Card Specific Fees -->
        <nz-collapse [nzBordered]="true" [nzAccordion]="true" [nzExpandIconPosition]="'end'" class="card">
          <nz-collapse-panel
            [nzHeader]="'cardDetails.fees.cardSpecificFees.title' | translate"
            [nzActive]="activePanels[3]"
            (nzActiveChange)="onPanelChange(3, $event)"
          >
            <div class="bg-[#fcfcfc] border border-[#eeeeef] rounded-2xl overflow-hidden mx-4 mb-4 mt-2 p-4">
              <div class="flex items-center">
                <!-- Description Column -->
                <div class="flex-1 flex flex-col">
                  <!-- Table Header -->
                  <div class="flex items-center h-10 px-6 py-2 bg-[#fcfcfc] border-b border-[#eeeeef]">
                    <p class="text-[15px] font-bold text-[#2c3035]">
                      {{ 'cardDetails.fees.standardFees.description' | translate }}
                    </p>
                  </div>

                  <!-- Table Rows -->
                  <div class="flex items-center h-14 px-6 py-2 bg-[#e6f2fa]">
                    <p class="text-[15px] font-bold text-[#393e44] line-clamp-2">
                      {{ 'cardDetails.fees.cardSpecificFees.cashReload' | translate }}
                    </p>
                  </div>

                  <div class="flex items-center h-14 px-6 py-2 bg-[#fcfcfc]">
                    <p class="text-[15px] font-bold text-[#393e44] line-clamp-2">
                      {{ 'cardDetails.fees.cardSpecificFees.customerService' | translate }}
                    </p>
                  </div>

                  <div class="flex items-center h-14 px-6 py-2 bg-[#e6f2fa]">
                    <p class="text-[15px] font-bold text-[#393e44] line-clamp-2">
                      {{ 'cardDetails.fees.cardSpecificFees.atmBalanceInquiry' | translate }}
                    </p>
                  </div>

                  <div class="flex items-center h-14 px-6 py-2 bg-[#fcfcfc]">
                    <p class="text-[15px] font-bold text-[#393e44] line-clamp-2">
                      {{ 'cardDetails.fees.cardSpecificFees.inactivity' | translate }}
                    </p>
                  </div>
                </div>

                <!-- Fee Column -->
                <div class="w-[114px] flex flex-col">
                  <!-- Table Header -->
                  <div class="flex items-center justify-end h-10 px-6 py-2 bg-[#fcfcfc] border-b border-[#eeeeef]">
                    <p class="text-[15px] font-bold text-[#2c3035]">
                      {{ 'cardDetails.fees.standardFees.fee' | translate }}
                    </p>
                  </div>

                  <!-- Table Rows -->
                  <div class="flex items-center justify-end h-14 px-6 py-2 bg-[#e6f2fa]">
                    <p class="text-[15px] text-[#393e44]">$0-$4.99</p>
                  </div>

                  <div class="flex items-center justify-end h-14 px-6 py-2 bg-[#fcfcfc]">
                    <p class="text-[15px] text-[#393e44]">$0.00</p>
                  </div>

                  <div class="flex items-center justify-end h-14 px-6 py-2 bg-[#e6f2fa]">
                    <p class="text-[15px] text-[#393e44]">$0.50</p>
                  </div>

                  <div class="flex items-center justify-end h-14 px-6 py-2 bg-[#fcfcfc]">
                    <p class="text-[15px] text-[#393e44]">$1.00</p>
                  </div>
                </div>
              </div>
            </div>
          </nz-collapse-panel>
        </nz-collapse>
      </div>
    </div>
  </div>
</div>
